import React from "react";
import {
  Box,
  TextField,
  InputAdornment,
  MenuItem,
  Tabs,
  Tab,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

// =============================================================================
// TableToolbar — search box + optional status tabs + optional dropdown filters
// + an actions slot, laid out consistently above a DataTable.
//
// props:
//   search, onSearchChange, searchPlaceholder
//   tabs?: [{ label, value }]           statusValue, onTabChange
//   filters?: [{ label, value, onChange, options:[{label,value}] }]
//   actions?: node
// =============================================================================
const TableToolbar = ({
  search,
  onSearchChange,
  searchPlaceholder = "Search…",
  tabs,
  tabValue,
  onTabChange,
  filters = [],
  actions,
}) => {
  return (
    <Box sx={{ mb: 2 }}>
      {tabs?.length > 0 && (
        <Tabs
          value={tabValue}
          onChange={(_, v) => onTabChange(v)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            mb: 2,
            minHeight: 40,
            "& .MuiTab-root": { minHeight: 40, textTransform: "none" },
          }}
        >
          {tabs.map((t) => (
            <Tab key={t.value} label={t.label} value={t.value} />
          ))}
        </Tabs>
      )}

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1.5,
          alignItems: "center",
        }}
      >
        {typeof search === "string" && (
          <TextField
            size="small"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder={searchPlaceholder}
            sx={{ minWidth: 240, flexGrow: 1, maxWidth: 380 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
        )}

        {filters.map((f) => (
          <TextField
            key={f.label}
            select
            size="small"
            label={f.label}
            value={f.value}
            onChange={(e) => f.onChange(e.target.value)}
            sx={{ minWidth: 160 }}
          >
            {f.options.map((o) => (
              <MenuItem key={o.value} value={o.value}>
                {o.label}
              </MenuItem>
            ))}
          </TextField>
        ))}

        <Box sx={{ flexGrow: 1 }} />
        {actions && (
          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>{actions}</Box>
        )}
      </Box>
    </Box>
  );
};

export default TableToolbar;
